export default "__VITE_ASSET__BQ53LK0d__"